<template>
  <CCard class="dataTable py-5 mt-3">
    <CRow class="pt-5 pb-4">
      <CCol sm="12" class="d-flex flex-column">
        <div>
          <h2 class="titlePage font-weight-normal text-capitalize mb-1">{{ $t('settings.profile.organization.user.header.users') }}</h2>
          <CAlert :color="this.$route.params.status" closeButton v-if="this.$route.params.message" :show.sync="currentAlertCounter">
            <center>
              <strong>{{ this.$route.params.message }}</strong>
            </center>
            <CProgress :max="10" :value="currentAlertCounter" height="3px" :color="this.$route.params.status" animate />
          </CAlert>
        </div>
      </CCol>
    </CRow>
    <CCardHeader class="dataTable__header d-flex justify-content-between px-0 pb-5">
      <div class="dataTable__countContants">
        <h3 class="font-weight-normal text-gray-600 mt-3 d-flex align-items-sm-center">
          {{ totalRecords || 0 }}
          <span v-if="totalRecords == 1" class="font-sm font-weight-normal text-uppercase ml-2">{{
            $t('settings.profile.organization.user.text.user')
          }}</span>
          <span v-if="totalRecords > 1" class="font-sm font-weight-normal text-uppercase ml-2">{{
            $t('settings.profile.organization.user.text.users')
          }}</span>
        </h3>
      </div>
      <div class="dataTable__search">
        <CInput
          type="search"
          :placeholder="$t('settings.profile.organization.user.placeholder.search')"
          addInputClasses="pl-5"
          class="iconSearchPlaceholder pb-0"
          v-model="tableFilterValue"
        ></CInput>
      </div>
      <div v-if="canAddUser" class="dataTable__buttonLink">
        <router-link class="btn btn-primary px-4 py-3 font-weight-bold" tag="button" :to="{ name: 'users-invite' }">{{
          $t('settings.profile.organization.user.link.addUser')
        }}</router-link>
      </div>

      <!-- <button @click="testeAcc">acc</button> -->
    </CCardHeader>

    <transition name="fade">
      <MenssageAlert :messages="messages" />
    </transition>

    <HeaderActions
      :show="{
        checkItems: true,
        approveRefuse: this.showApproveRefuse,
        associate: this.showAssociate,
        delete: this.showDelete,
        manage: false,
        filterBy: false,
      }"
      :multiSelect="true"
      :itemsListSelected="Boolean(itemsListSelected.length)"
      :activeRegister="isActivable"
      :inactiveRegister="isInactivable"
      @checkAll="checkAll"
      @confirm="deleteItemsSelected"
      @confirm-active="activeUser"
      @confirm-inactive="inactiveUser"
      @filterBy="chooseFilterBy"
      @approveOrReprove="approveOrReprove"
    />

    <CCardBody class="dataTable__body p-0">
      <CDataTable
        :items="registers"
        :fields="headers"
        :table-filter="{ external: true, lazy: true }"
        :table-filter-value.sync="tableFilterValue"
        items-per-page-select
        @row-clicked="selectItem"
        :items-per-page.sync="itemsPerPage"
        @pagination-change="paginationChange"
        :active-page="1"
        hover
        :loading="loading"
      >
        <template #loading>
          <div class="d-flex justify-content-center align-items-center dataTable__loading">
            <CSpinner class="my-3" color="primary" />
          </div>
        </template>

        <template #select="{ item }">
          <td @click.stop>
            <CInputCheckbox class="text-center checkboxTable" :checked="item._selected" @update:checked="() => check(item)" custom />
          </td>
        </template>

        <template #organizationUserStatus="{ item }">
          <td>
            <span :class="statusInviteClass(item.organizationUserStatus)" class="text-capitalize">{{
              statusInvite(item.organizationUserStatus)
            }}</span>
          </td>
        </template>

        <template #answerOrganizationUserId="{ item }">
          <td>
            <span>{{ item.answerOrganizationUserId || '' }}</span>
          </td>
        </template>

        <template #email="{ item }">
          <td>
            <span>{{ item.email }}</span>
          </td>
        </template>
        <template #inviteId="{ item }">
          <td>
            <span v-if="item.organizationUserStatus == 3" class="resendEmail" @click.stop="resendEmail(item.inviteId)"
              ><CIcon style="margin-top: -3px" class="ml-2 mr-1" name="email" :height="20" viewBox="0 0 32 32" />{{
                $t('settings.profile.organization.user.coluna.resendEmail')
              }}</span
            >
          </td>
        </template>

        <template #createdDateTime="{ item }">
          <td>
            {{ formatDate(item.createdDateTime) }}
          </td>
        </template>
      </CDataTable>
    </CCardBody>

    <div class="position-relative">
      <CPagination
        v-show="pages > 0 && totalRecords > 0"
        align="center"
        :pages="pages"
        :active-page.sync="activePage"
        class="dataTable__newPagination mt-3"
      >
        <template slot="previous-button">
          <span class="newPagination__button p-2 btnPagination">
            {{ $t('audience.audienceList.text.prev') }}
          </span>
        </template>
        <template slot="next-button">
          <span class="newPagination__button p-2 btnPagination">
            {{ $t('audience.audienceList.text.next') }}
          </span>
        </template>
      </CPagination>
      <CElementCover v-if="loading" :opacity="0.8" style="z-index: 1001">
        <div></div>
      </CElementCover>
    </div>
  </CCard>
</template>

<script>
const headerLabel = [
  {
    key: 'select',
    label: '',
    _classes: 'hidde',
    _style: 'width:50px',
  },
  { key: 'name', label: 'NAME' },
  { key: 'email', label: 'EMAIL' },
  { key: 'inviteId', label: '' },
  { key: 'organizationUserStatus', label: 'STATUS' },
  { key: 'roleName', label: 'PROFILE' },
  { key: 'createdDateTime', label: 'DATE CREATED' },
]

import HeaderActions from '@/components/table/HeaderActions'
import MenssageAlert from '@/components/MenssageAlert'
import { dateTimeFormatString } from '../../../utils/dateUtil'
import services from '../user-services'
import { mapGetters } from 'vuex'

const OrganizationsStatusNames = {
  Inactive: 1,
  Active: 2,
  PendingInviteAcceptance: 3,
}

const OrganizationsStatusCodes = {
  1: 'Inactive',
  2: 'Active',
  3: 'PendingInviteAcceptance',
}

export default {
  name: 'UserList',
  components: {
    MenssageAlert,
    HeaderActions,
  },
  data() {
    return {
      columnFilterValue: {},
      tableFilterValue: null,
      loadedItems: [],
      loading: false,
      itemsPerPage: 10,
      pages: 0,
      headers: [],
      totalPendings: 0,
      totalRecords: 0,
      itemsListSelected: [],
      activePage: 1,
      responsive: false,
      messages: [],
      SenderStatusId: null,
      OrganizationStatusId: null,
      collapseDuration: 0,
      details: [],
      invites: [],
      organizationId: this.$store.state.auth.organizationId,
      userId: this.$store.state.auth.user.id,
      currentAlertCounter: 5,
      totalInvites: null,
      activableList: [],
      isActivable: false,
      isInactivable: false,
      pagination: [],
      organizationUserId: null,
      userId: null,
    }
  },

  created() {
    this.getData({
      Page: this.activePage,
      Count: this.itemsPerPage,
    })
  },

  mounted() {
    this.$root.$on('approveOrReprove', (obj) => {
      this.approveOrReprove(obj)
    })

    this.getOrganizationUsers()
  },

  watch: {
    reloadParams() {
      this.onTableChange()
    },
    itemsListSelected(newValue) {
      if (newValue && newValue.length > 0) {
        let items = []

        if (!Array.isArray(newValue)) {
          this.isActivable = false
          this.isInactivable = false
        }

        newValue.forEach((item) => {
          let value = this.loadedItems.find((elm) => elm._id === item)
          if (value) {
            items.push(value)
          }
        })

        if (items.length > 1 || items.length == 0) {
          this.isActivable = false
          this.isInactivable = false
          return
        }
        this.isActivable = items[0].organizationUserStatus == OrganizationsStatusNames['Inactive']
        this.isInactivable = items[0].organizationUserStatus == OrganizationsStatusNames['Active']
        // .filter(elm => elm.organizationUserStatus ? elm.organizationUserStatus !== OrganizationsStatusNames['Active'] : false).length === 0 && items.length > 1
        // this.isInactivable = items.filter(elm => elm.organizationUserStatus ? elm.organizationUserStatus != OrganizationsStatusNames['Inactive'] : false).length == 0// item.organizationUserStatus == 1 ? true : false
      } else {
        this.isActivable = false
        this.isInactivable = false
      }
    },
  },

  computed: {
    ...mapGetters({
      hasSessionPermission: 'auth/hasSessionPermission',
    }),

    registers() {
      return this.loadedItems.map((user, index) => {
        return {
          ...user,
          _selected: this.itemsListSelected.includes(index),
          _classes: [user._classes, user._selected || this.itemsListSelected.includes(index) ? 'table-selected' : ''],
        }
      })
    },

    itemsPending() {
      return 0
      // return this.loadedItems.find(item => item.statusIdto == 1)
    },

    showApproveRefuse() {
      // só mostra a featuea de aprovação se  status por pedding
      const item = this.loadedItems.find((item) => item.id == this.itemsListSelected) || null
      return item ? item.statusId == 1 : null // 1 == pedding
    },

    showAssociate() {
      // só mostra a feature de associaçao se  status por approved
      const item = this.loadedItems.find((item) => item.id == this.itemsListSelected) || null
      return item ? item.statusId == 2 : null // 2 == approved
    },

    reloadParams() {
      return [this.activePage, this.itemsPerPage, this.tableFilterValue, this.SenderStatusId, this.OrganizationStatusId]
    },

    detailPagination() {
      const first = (this.activePage - 1) * this.itemsPerPage
      const totalPage = this.activePage * 10 > this.totalRecords ? this.totalRecords : this.activePage * 10
      return `${first} - ${totalPage}  of ${this.totalRecords}`
    },

    showDelete() {
      const itemsPending = this.loadedItems.filter((loadedItem) => !!loadedItem.inviteId)

      const hasAnyItemPendingSelected = itemsPending.some((item) => this.itemsListSelected.indexOf(item._id) > -1)

      return !hasAnyItemPendingSelected || this.hasSessionPermission('Organization_DeleteInvite')
    },

    canAddUser() {
      return this.hasSessionPermission('Organization_SendInvite')
    },
  },

  methods: {
    resendEmail(inviteId) {
      this.messages = []

      let body = {}

      services
        .resendInvite(inviteId, body)
        .then((response) => {
          this.getData({
            Page: this.activePage,
            Count: this.itemsPerPage,
          })

          this.messages.push({
            status: 'success',
            text: 'An invite has been sent to the user.',
          })
        })
        .catch(({ response }) => {
          this.messages.push({
            status: 'danger',
            text: response.data.Message || 'We had an error trying to send the',
          })
        })
        .finally(() => {})
    },
    formatDate(date) {
      return date ? dateTimeFormatString(date) : ''
    },

    headerHandle() {
      return [
        {
          key: 'select',
          label: '',
          _classes: 'hidde',
          _style: 'width:50px',
        },
        { key: 'name', label: this.$t('sender.domainSender.domainSenderList.status.name') },
        { key: 'email', label: this.$t('sender.domainSender.domainSenderList.status.email') },
        { key: 'inviteId', label: '' },
        { key: 'organizationUserStatus', label: this.$t('sender.domainSender.domainSenderList.status.status') },
        { key: 'roleName', label: this.$t('sender.domainSender.domainSenderList.status.profile') },
        { key: 'createdDateTime', label: this.$t('sender.domainSender.domainSenderList.status.dateCreated') },
      ]
    },

    mountItemsTable(arr) {
      return arr.reduce((acc, cur, index) => {
        acc.push({
          ...cur,
          _id: index,
          _toggled: false,
          index: index,
          _classes: [cur._selected ? 'table-selected' : null],
        })
        return acc
      }, [])
    },

    getData(data) {
      this.loading = true
      services
        //.getUsers({ params: data }, this.organizationId)
        .getUsers(data.Page, data.Count, this.organizationId)
        .then((invites) => {
          this.invites = invites.data.data.items
          this.pages = Math.ceil(invites.data.data.pageOptionsResponse.totalRecords / 10)
          this.totalInvites = invites.data.data.items.length
          this.totalRecords = invites.data.data.pageOptionsResponse.totalRecords
          this.activePage = invites.data.data.pageOptionsResponse.currentPage
          this.headers = this.headerHandle()
          this.loadedItems = this.mountItemsTable(invites.data.data.items)
          this.pagination = invites.data.data.pageOptionsResponse
        })
        .catch(() => {
          this.loadedItems = []
        })
        .finally(() => {
          this.loading = false
        })
    },

    onTableChange() {
      this.loading = true
      this.getData({
        Page: this.activePage,
        Count: this.itemsPerPage,
      })
    },

    paginationChange(a) {
      this.itemsPerPage = a
    },

    check(item) {
      const val = Boolean(this.loadedItems[item.index]._selected)
      this.$set(this.loadedItems[item.index], '_selected', !val)
      this.checkedItem(item._id)
    },

    checkAll(state) {
      this.loadedItems.map((item) => {
        this.$set(this.loadedItems[item.index], '_selected', state)
      })

      this.checkedAllitems(state)
    },

    checkedAllitems(state) {
      if (!state) {
        this.itemsListSelected = []
        return
      }
      this.itemsListSelected = this.loadedItems.reduce((acc, cur) => {
        acc.push(cur._id)
        return acc
      }, [])
    },

    checkedItem(id = '') {
      if (this.itemsListSelected.includes(id)) {
        this.itemsListSelected = this.itemsListSelected.filter((item) => item !== id)
        return
      }

      this.itemsListSelected.push(id)
    },

    uncheckAllItems() {
      this.loadedItems.map((item) => {
        this.$set(this.loadedItems[item.index], '_selected', false)
      })

      this.itemsListSelected = []
    },

    isApprovedSender(id) {
      return this.loadedItems.filter((item) => item.id == id)[0].statusId == 2 //approved
    },

    deleteItemsSelected() {
      this.messages = []
      let list = []
      let inviteList = []
      // services
      //   .deleteUserInvite({data:  this.itemsListSelected})
      //   .then(({ data }) => {
      //     this.messages.push({
      //       status: "success",
      //       text: "The selected invites have been cancelled."
      //     });

      //     setTimeout(() => {
      //       this.onTableChange();
      //       this.itemsListSelected = [];
      //     }, 1000);
      //   })
      //   .catch(({ response }) => {
      //     this.messages.push({
      //       status: "danger",
      //       text: response.data.message
      //     });
      //   });
      if (this.itemsListSelected.length > 0) {
        this.itemsListSelected.forEach((elm) => {
          let obj = this.loadedItems.find((elme) => elme._id === elm)
          this.organizationUserId = obj.organizationUserId
          this.userId = obj.userId

          if (obj.inviteId) {
            inviteList.push(obj.inviteId)
          }
          if (obj.userId) {
            list.push(services.deleteUserFromOrganization(this.$store.state.auth.organizationId, obj.userId))
          }
        })

        if (inviteList.length > 0) {
          list.push(services.deleteUserInvite({ data: inviteList }))
        }

        this.loading = true

        Promise.all(list)
          .then(() => {
            if (this.$store.state.auth.user.id == this.userId) {
              this.logout()
            }
            this.messages.push({
              status: 'success',
              text: this.$t('settings.user.userList.messages.success-delete'),
            })
            // this.uncheckAllIt
            this.checkAll(false)
            this.onTableChange()
          })
          .catch(({ response }) => {
            this.messages.push({
              status: 'danger',
              text: response.data.message,
            })
          })
          .finally(() => {
            this.loading = false
          })
      }
    },

    logout() {
      var userId = this.$store.state.auth.user.id
      services.logout(userId).then(() => {
        this.$store.dispatch('auth/logout')
      })
    },

    deleteEachItem(Itemid) {
      services
        .deleteUserInvite(Itemid)
        .then(({ data }) => {})
        .catch(({ response }) => {
          this.messages.push({
            status: 'danger',
            text: response.data.message,
          })
        })
    },

    statusOrder(position) {
      const positions = {
        1: 'pending',
        2: 'approved',
        3: 'refused',
      }

      return positions[position] || positions.default
    },

    statusInvite(status) {
      if (status == 1) {
        return this.$t('sender.domainSender.domainSenderList.status.inactive')
      } else if (status == 2) {
        return this.$t('sender.domainSender.domainSenderList.status.active')
      } else if (status == 3) {
        return this.$t('sender.domainSender.domainSenderList.status.pending')
      } else {
        return this.$t('sender.domainSender.domainSenderList.status.unknown')
      }
    },

    statusInviteClass(status) {
      if (status == 1) {
        return 'refused'
      } else if (status == 2) {
        return 'approved'
      } else {
        return 'unknown'
      }
    },

    chooseFilterBy(item) {
      this.SenderStatusId = null
      this.OrganizationStatusId = null

      if (item === 'all') {
        return
      }

      this[item.column] = item.value
    },

    toggleDetails(item, index) {
      this.$set(this.loadedItems[index], '_toggled', !item._toggled)
      this.collapseDuration = 300
      this.$nextTick(() => {
        this.collapseDuration = 0
      })
    },

    approveOrReprove(obj) {
      this.messages = []
      try {
        let item = this.loadedItems.find((item) => item.id === this.itemsListSelected)
        let organizationId = this.$store.state.auth.organizationId

        services
          .approveorreject(organizationId, {
            senderRequestId: item.id,
            sender: item.sender,
            status: obj.status,
            reasonText: obj.reasonText,
          })
          .then(() => {
            this.onTableChange()
          })
          .catch((error) => {
            this.messages.push({
              status: 'danger',
              text: error.response.data.message,
            })
          })
      } catch (error) {
        this.messages.push({
          status: 'danger',
          text: error.response.data.message || '',
        })
      }
    },

    getOrganizationUsers() {
      this.$store.dispatch('senders/organizationUsers', this.$store.state.auth.organizationId)
    },

    getProfileLabel(roleId) {
      const positions = {
        5: 'SuperAdmin',
        6: 'Analyst',
        7: 'Guest',
      }
      return positions[roleId] || ''
    },

    activeUser() {
      if (this.itemsListSelected.length > 0) {
        let value = this.loadedItems.find((elm) => elm._id === this.itemsListSelected[0])
        let organizationId = this.$store.state.auth.organizationId
        if (value && value.userId) {
          this.messages = []
          services
            .activeUser(organizationId, value.userId)
            .then((res) => {
              this.messages.push({
                status: 'success',
                text: this.$t('user.userList.message.active-success'),
              })
              // this.uncheckAllItems()
              this.checkAll(false)
              this.onTableChange()
            })
            .catch((error) => {
              this.messages.push({
                status: 'danger',
                text: error.response.data.message,
              })
            })
        }
      }
    },

    inactiveUser() {
      if (this.itemsListSelected.length > 0) {
        let value = this.loadedItems.find((elm) => elm._id === this.itemsListSelected[0])
        let organizationId = this.$store.state.auth.organizationId

        if (value && value.organizationUserId) {
          this.messages = []
          services
            .inactiveUser(organizationId, value.userId)
            .then((res) => {
              this.messages.push({
                status: 'success',
                text: this.$t('user.userList.message.inactive-success'),
              })
              // this.uncheckAllItems()
              this.checkAll(false)
              this.onTableChange()
            })
            .catch((error) => {
              this.messages.push({
                status: 'danger',
                text: error.response.data.message,
              })
            })
        }
      }
    },

    selectItem(row) {
      if (row.inviteId) {
        this.$router.push({ name: 'users-edit-invite', params: { inviteId: row.inviteId } })
        return
      }
      if (row.userId) {
        this.$router.push({ name: 'users-edit-user-organization', params: { userId: row.userId } })
        return
      }
    },
  },
}
</script>
<style scoped lang="scss">
.resendEmail:hover {
  color: #ff5924 !important;
}
.resendEmail {
  color: #a1a8b3;
  font-size: 13px;
  text-decoration: underline;
}
.pending {
  color: var(--warning);
}

.active,
.approved {
  color: var(--success);
}

.refused {
  color: var(--danger);
}

.listItem__download {
  cursor: pointer;
}

.listItem__name {
  flex: 0 0 20%;
  min-width: 250px;
}

.listItem__numbers {
  font-size: $font-size-xs;
  position: relative;
}

.listItem__detail {
  flex-wrap: wrap;
}

.listItem__detailItem {
  flex: 0 0 25%;
  margin-bottom: 2%;

  &.big {
    flex: 0 0 50%;
  }
}
</style>

<style module>
.blockClick {
  pointer-events: none;
}
</style>
